import script from "./ClickHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ClickHistory.vue?vue&type=script&setup=true&lang=js"

import "./ClickHistory.vue?vue&type=style&index=0&id=c0b45312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0b45312"]])

export default __exports__